import { isValidHttpUrl } from "./url";

export type Environment = "production" | "integration" | "staging" | "local" | "development" | "demo" | "unknown";

export const detectEnvironment = (apiUrl?: string): Environment => {
  if (!apiUrl) {
    return "development";
  }
  if (!isValidHttpUrl(apiUrl)) {
    return "unknown";
  }
  const url = new URL(apiUrl);
  // list of domains can be found in https://wiki.dev.jobrad.org/display/LEASERAD/Domains
  if (/^portal\.jobrad.org$/i.test(url.hostname)) return "production";
  if (/^portal\.staging\.jobrad.org$/i.test(url.hostname)) return "staging";
  if (/^portal\.integration\.jobrad.org$/i.test(url.hostname)) return "integration";
  if (/^portal\.[^.]+\.dev\.jobrad\.org$/i.test(url.hostname)) return "development";
  if (/^portal\.leaserad.local.de$/i.test(url.hostname)) return "local";

  return "development";
};

export function environmentFromUrl(hostname: string, devMode: boolean): Environment {
  if (devMode) {
    return "local";
  }

  if (hostname.endsWith("dev.jobrad.org")) {
    return "development";
  }

  if (hostname.endsWith("jobrad.dev")) {
    return "development";
  }

  if (hostname.endsWith("leaserad.local.de")) {
    return "local";
  }

  if (hostname.endsWith("integration.jobrad.org")) {
    return "integration";
  }

  if (hostname.endsWith("staging.jobrad.org")) {
    return "staging";
  }

  if (hostname.endsWith("demo.dev.jobrad.org")) {
    return "demo";
  }

  if (hostname.endsWith("www.jobrad.org") || hostname.endsWith("portal.jobrad.org")) {
    return "production";
  }

  return "unknown";
}
